const mediaItems = [
  {
    title: '娱乐圈年度最大瓜深度复盘',
    duration: '15:28',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20entertainment%20gossip%20news%20visual%20with%20warm%20coral%20tones%2C%20abstract%20shapes%20representing%20viral%20social%20media%20content%2C%20modern%20magazine%20layout%20aesthetic%2C%20clean%20composition%20with%20soft%20gradient%20background%2C%20sophisticated%20design%20style&width=600&height=340&seq=media-01-51cg&orientation=landscape',
  },
  {
    title: '顶流塌房事件全时间线梳理',
    duration: '22:15',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20trending%20social%20media%20scandal%20coverage%20with%20amber%20and%20warm%20orange%20color%20scheme%2C%20abstract%20geometric%20pattern%20representing%20breaking%20news%2C%20editorial%20design%20with%20clean%20lines%20and%20soft%20gradients&width=600&height=340&seq=media-02-51cg&orientation=landscape',
  },
  {
    title: '网红圈翻车实录：那些年我们吃过的瓜',
    duration: '18:42',
    views: '85万',
    img: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20editorial%20illustration%20of%20internet%20celebrity%20controversy%20and%20viral%20gossip%20topics%2C%20warm%20coral%20and%20peach%20gradients%2C%20abstract%20bubble%20shapes%20representing%20social%20media%20trends%2C%20modern%20clean%20aesthetic&width=600&height=340&seq=media-03-51cg&orientation=landscape',
  },
  {
    title: '品牌公关翻车事件大盘点',
    duration: '12:55',
    views: '72万',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20visual%20of%20brand%20PR%20crisis%20and%20public%20opinion%20tracking%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20abstract%20radar%20and%20graph%20shapes%2C%20modern%20magazine%20style%20composition%20with%20soft%20gradient%20background&width=600&height=340&seq=media-04-51cg&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            吃瓜视频
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            热门事件视频盘点，吃瓜更直观
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {mediaItems.map((item) => (
              <div
                key={item.title}
                className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:bg-background-100/80 transition-colors"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                    <div className="w-11 h-11 rounded-full bg-white/90 flex items-center justify-center">
                      <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
                    {item.duration}
                  </span>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-relaxed">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1.5 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次播放
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}